import { useTrackView } from '#src/app/shared/hooks/tracking';

export function useTrackPageView(slug: string): void {
	useTrackView('impact_story_page_view', { slug });
}
